import { render, staticRenderFns } from "./RegisterSuccess.vue?vue&type=template&id=5d44f62d&scoped=true&"
import script from "./RegisterSuccess.vue?vue&type=script&lang=ts&"
export * from "./RegisterSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterSuccess.vue?vue&type=style&index=0&id=5d44f62d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d44f62d",
  null
  
)

export default component.exports